/* hgn-kit-progress.js — moved verbatim from snippets/hgn-kit-progress.liquid on 2026-09-16 (page-weight phase B:
   inline JS → theme asset, loaded synchronously at the same position so execution order and
   DOMContentLoaded timing are unchanged). 4 original <script> block(s), in order.
   EDIT THIS FILE, not the snippet. */

/* ---- original <script> block #1 of 4 ---- */

(function () {
  'use strict';

  if (window.HGN && window.HGN.kitProgress) return;

  var SCHEMA_VERSION = 2;
  var STORAGE_PREFIX = 'hgn-kit-progress:';
  /* Manifest map cart-line-key → { tier, itemId } so the side cart can
     prune kit memory when the shopper removes a cart line that came
     from a kit transfer (toggle OFF). Per-customer like the main
     state. */
  var MANIFEST_PREFIX = 'hgn-kit-manifest:';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
  var KIT_TIERS = ['classic', 'gels', 'press-ons']; // accessories handled per-kit, not as a tier

  /* ───────── Curation-aware kit naming (2026-09-15) ─────────
     A kit prefilled from a curated edit remembers WHICH edit it came
     from, so every surface that names the kit can say "your Halloween
     Edit" instead of the generic tier name. See KIT-BUILD.md §11h.

     TIER_LABEL is the built-in generic name; the merchant's own
     strings (announcement-bar settings → HGN_KIT_BAR_COPY) win when
     they are set, so the name stays merchant-editable in ONE place
     and every consumer resolves it identically. */
  var TIER_LABEL = {
    classic:     'Classic Wraps Kit',
    gels:        'Gel Wraps Kit',
    'press-ons': 'Press-On Kit'
  };
  var TIER_LABEL_COPY_KEY = {
    classic:     'tierLabelClassic',
    gels:        'tierLabelGels',
    'press-ons': 'tierLabelPressOn'
  };
  /* Hard ceiling on the rendered edit name. The kit bar is a 38 px
     strip — a merchant title long enough to wrap there is trimmed
     here so every consumer gets the same short string (the bar also
     ellipses in CSS; this keeps the drawer + collage honest too). */
  var EDIT_LABEL_MAX = 34;

  /* Per-market enable flags. Sourced from window.HGN_KIT_ENABLED
     (emitted by hgn-announcement.liquid from section settings).
     `isTierEnabled` defaults to true when the global isn't present
     so the controller stays usable on pages where the announcement
     bar hasn't loaded yet (legacy preview pages, etc).

     Availability guard (2026-07-13): a tier is only offerable when
     EVERY required accessory slot has at least one configured option
     in window.HGN_KIT_ACCESSORIES — a kit whose required slot renders
     zero options can never pass accessoriesComplete(), so the shopper
     would dead-end at the accessory step (discovered via the UK-only
     LED lamp: gel kits silently couldn't complete on non-UK markets).
     The guard is PERMISSIVE on anything ambiguous — global not yet
     loaded, tier or slot key missing from the broadcast — so a boot
     race can never hide a tier; only a CONFIRMED-empty options array
     hides it. The tier auto-returns the moment the market's
     announcement settings carry the product again. */
  function isTierEnabled(tier) {
    var map = window.HGN_KIT_ENABLED;
    if (map && map[tier] === false) return false;
    var accData = window.HGN_KIT_ACCESSORIES;
    if (!accData) return true;            // not loaded yet — permissive
    var tierAcc = accData[tier];
    if (!tierAcc) return true;            // tier absent from broadcast — permissive
    /* REQUIRED_ACCESSORY_SLOTS is declared further down this IIFE
       (hoisted var, assigned later) — stay permissive if this runs
       before the assignment. */
    var required = REQUIRED_ACCESSORY_SLOTS ? REQUIRED_ACCESSORY_SLOTS[tier] : null;
    if (!required) return true;
    for (var i = 0; i < required.length; i++) {
      /* Gift slots never hide a tier — an empty gift slot means the
         kit ships without the freebie, not that it can't ship at all.
         See GIFT_SLOTS below. Integral components (top coat / lamp /
         remover) keep the original hide-the-tier behaviour. */
      if (GIFT_SLOTS.indexOf(required[i]) !== -1) continue;
      var options = tierAcc[required[i]];
      /* Only a confirmed-empty array hides the tier; a missing /
         malformed slot key means an older broadcast — permissive. */
      if (Array.isArray(options) && options.length === 0) return false;
    }
    return true;
  }
  function getEnabledTiers() {
    return KIT_TIERS.filter(isTierEnabled);
  }

  /* Accessory slot names per tier — used by the kit-bar drawer's
     accessory step UI and by the bundle prefill pipeline. The drawer
     calls `setAccessory(tier, slot, value)` with one of these slot
     names; reads via `getAccessory(tier, slot)`. */
  /* Slot list per tier. `magicRemover` (classic + gels) is an optional
     upsell — included here so setAccessory()/getAccessory() recognise
     it, but deliberately omitted from REQUIRED_ACCESSORY_SLOTS below
     so the kit can finalise without it. */
  var ACCESSORY_SLOTS = {
    classic:     ['topCoat', 'magicRemover', 'giftBag'],
    gels:        ['uvLamp', 'magicRemover', 'giftBag'],
    'press-ons': ['remover', 'tabs', 'glue', 'giftBag']
  };

  /* ───────── Gift slots (droppable requirements) ─────────
     Slots that are required in the normal case but that the kit can
     ship WITHOUT when the merchant's options all run out. Everything
     else in REQUIRED_ACCESSORY_SLOTS is an integral kit component —
     a gel kit with no lamp genuinely can't ship, so an empty lamp
     slot must still hide the tier (the UK-only LED lamp lesson in
     isTierEnabled above). A gift is different: the kit is still a
     complete, sellable product without it.

     Added 2026-08-02, as the Mani Make-up Bags ran down. Before this,
     an emptied gift slot had two failure modes and both were bad:
     leave the pickers set and every kit finalise 422s (the cart bulk
     add is all-or-nothing, so one dead accessory kills the whole
     kit); clear the pickers and isTierEnabled hid all three tiers
     site-wide. Now the slot simply disappears and the kit completes
     without it. Fully reversible — restock and the slot returns with
     no code change. */
  var GIFT_SLOTS = ['giftBag'];

  /* True unless the broadcast CONFIRMS this slot has zero options.
     Permissive on every ambiguity — global absent, tier missing, slot
     key missing or malformed — so a boot race can never strip a slot
     that is actually configured. Mirrors isTierEnabled's philosophy.

     Note the availability filtering itself happens upstream in
     hgn-announcement.liquid: sold-out products are dropped from the
     broadcast, so "zero options" here means "nothing left to give". */
  function slotHasOptions(tier, slot) {
    var accData = window.HGN_KIT_ACCESSORIES;
    if (!accData) return true;
    var tierAcc = accData[tier];
    if (!tierAcc) return true;
    var options = tierAcc[slot];
    if (!Array.isArray(options)) return true;
    return options.length > 0;
  }

  /* The required slots that actually apply RIGHT NOW — the canonical
     table minus any gift slot with nothing left to offer. This is the
     value every consumer should read; `kp.REQUIRED_ACCESSORY_SLOTS` is
     a getter over it so the 9 existing call sites stay correct without
     each needing to know about gift-slot degradation. */
  function requiredSlotsFor(tier) {
    var base = REQUIRED_ACCESSORY_SLOTS[tier];
    if (!base) return [];
    return base.filter(function (slot) {
      if (GIFT_SLOTS.indexOf(slot) === -1) return true;
      return slotHasOptions(tier, slot);
    });
  }

  /* Drop stored gift picks whose option is no longer on offer — the
     shopper chose a bag, that colour sold out, and the announcement
     bar stopped broadcasting it. Without this the dead variantId sits
     in kit memory and Shopify 422s the entire bulk cart-add at
     finalise. Strictly a no-op while the broadcast is absent or
     ambiguous, so a boot race can't wipe a valid pick. */
  function pruneUnavailableGiftPicks() {
    var accData = window.HGN_KIT_ACCESSORIES;
    if (!accData) return;
    KIT_TIERS.forEach(function (tier) {
      var tierAcc = accData[tier];
      if (!tierAcc) return;
      GIFT_SLOTS.forEach(function (slot) {
        var options = tierAcc[slot];
        if (!Array.isArray(options)) return;
        var pick = getAccessory(tier, slot);
        if (!pick || !pick.id) return;
        var stillOffered = options.some(function (o) {
          return o && String(o.id) === String(pick.id);
        });
        if (!stillOffered) clearAccessory(tier, slot);
      });
    });
  }

  /* The customer ID is stamped on the page-level data attribute by the
     existing wishlist surfaces — but those don't render on every page.
     Read from a global the theme exposes (`window.Shopify.customer`) or
     fall back to 'anon'. */
  function currentCustomerId() {
    if (window.Shopify && window.Shopify.customer && window.Shopify.customer.id) {
      return String(window.Shopify.customer.id);
    }
    /* Many HGN sections expose `data-customer-id` on their root — pick
       up the first one if Shopify global isn't set. */
    var node = document.querySelector('[data-customer-id]');
    if (node) {
      var id = node.getAttribute('data-customer-id');
      if (id && id !== 'anon') return id;
    }
    return 'anon';
  }

  /* Presentment currency the shopper is actually being priced in.
     `cart.currency` (stashed on window.HGN.cartCurrency by the side
     cart after every /cart.js fetch) is authoritative; the Shopify
     global reports the shop's BASE currency in Markets shops, so it
     is only the last resort. Same precedence hgn-currency.liquid and
     the side cart both use, so the three files can never disagree
     about which currency a figure is in. */
  function activePresentmentIso() {
    try {
      var cartCur = window.HGN && window.HGN.cartCurrency;
      if (cartCur) return String(cartCur).toUpperCase();
    } catch (e) {}
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    return String(cur).toUpperCase();
  }

  function storageKey(customerId) {
    return STORAGE_PREFIX + (customerId || 'anon');
  }
  function manifestStorageKey(customerId) {
    return MANIFEST_PREFIX + (customerId || 'anon');
  }

  /* Transfer manifest — persisted map of `cartLineKey` → `{ tier, itemId }`.
     Written when toggle-OFF migrates picks to cart; consulted when the
     side cart removes a cart line so we can prune the matching kit
     pick from localStorage. Survives page reloads. */
  function readManifest() {
    try {
      var raw = localStorage.getItem(manifestStorageKey(memoryCustomerId || currentCustomerId()));
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      return (parsed && typeof parsed === 'object') ? parsed : {};
    } catch (e) { return {}; }
  }
  function writeManifest(map) {
    try {
      var key = manifestStorageKey(memoryCustomerId || currentCustomerId());
      if (!map || Object.keys(map).length === 0) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify(map));
      }
    } catch (e) { /* swallow — quota / privacy mode */ }
  }
  function clearManifest() { writeManifest({}); }
  /* Public prune helper — side cart calls this with a cart line key
     when a line is removed. If the key is in the manifest, drop the
     matching kit pick from localStorage and remove the manifest entry.
     Returns the removed entry (or null). */
  function pruneManifestForLineKey(cartLineKey) {
    if (!cartLineKey) return null;
    var m = readManifest();
    var entry = m[cartLineKey];
    if (!entry) return null;
    delete m[cartLineKey];
    writeManifest(m);
    if (entry.tier && entry.itemId) {
      removeItem(entry.tier, entry.itemId);
    }
    return entry;
  }

  function emptyState() {
    return {
      version: SCHEMA_VERSION,
      activeKit: null,
      /* `focus` — the kit tier the shopper has committed to building
         this session. `null` = "haven't decided" (legacy behaviour:
         every kit-eligible product can be added to any tier). When
         set to a tier string, the ATC takeover only applies to cards
         in that tier and the side cart only renders that tier's
         kit-build section. Set via `setFocus()`; defaults to `null`. */
      focus: null,
      kits: {
        /* `edit` — the curated edit this tier's kit was started from,
           or null for a hand-built kit. Shape:
           { slug, title, skin, source, ids: [originalPickId, …], setAt }.
           `ids` is what makes the "name persists through swaps, drops
           when none of the original designs remain" rule decidable. */
        classic:     { items: [], updatedAt: 0, accessories: {}, edit: null },
        gels:        { items: [], updatedAt: 0, accessories: {}, edit: null },
        'press-ons': { items: [], updatedAt: 0, accessories: {}, edit: null },
        accessories: { items: [], updatedAt: 0 }
      }
    };
  }

  function clone(o) {
    /* Plain JSON clone — state is pure data, no Dates / functions. */
    return JSON.parse(JSON.stringify(o));
  }

  /* Defensive parse: accept legacy / malformed shapes and shape them
     into the current schema rather than throwing. */
  function normalise(parsed) {
    var out = emptyState();
    if (!parsed || typeof parsed !== 'object') return out;
    if (typeof parsed.activeKit === 'string' &&
        ['classic', 'gels', 'press-ons'].indexOf(parsed.activeKit) !== -1) {
      out.activeKit = parsed.activeKit;
    }
    if (typeof parsed.focus === 'string' &&
        ['classic', 'gels', 'press-ons'].indexOf(parsed.focus) !== -1) {
      out.focus = parsed.focus;
    }
    if (parsed.kits && typeof parsed.kits === 'object') {
      Object.keys(out.kits).forEach(function (tier) {
        var src = parsed.kits[tier];
        if (!src) return;
        if (Array.isArray(src.items)) {
          out.kits[tier].items = src.items.filter(function (it) {
            return it && it.id;
          });
        }
        if (typeof src.updatedAt === 'number') {
          out.kits[tier].updatedAt = src.updatedAt;
        }
        /* v1 → v2 migration: accessories field is new. v1 records
           have no `accessories` property, so we just default to
           `{}`. Existing items + active state are preserved. */
        if (KIT_TIERS.indexOf(tier) !== -1 &&
            src.accessories && typeof src.accessories === 'object' &&
            !Array.isArray(src.accessories)) {
          out.kits[tier].accessories = {};
          (ACCESSORY_SLOTS[tier] || []).forEach(function (slot) {
            var value = src.accessories[slot];
            if (value && typeof value === 'object' && value.id) {
              out.kits[tier].accessories[slot] = value;
            }
          });
        }
        /* v2 → curation-aware: `edit` is new and additive. Records
           written before 2026-09-15 simply have no `edit` key and
           default to null — no migration, no version bump. */
        if (KIT_TIERS.indexOf(tier) !== -1 && src.edit) {
          out.kits[tier].edit = sanitiseEdit(src.edit);
        }
      });
    }
    return out;
  }

  /* ───────── Edit record helpers ─────────
     Sanitise on the way IN (localStorage is shopper-writable and the
     title lands in shopper-facing copy), never on the way out. */
  function sanitiseEdit(edit) {
    if (!edit || typeof edit !== 'object') return null;
    var title = String(edit.title == null ? '' : edit.title).trim().slice(0, 120);
    var slug  = String(edit.slug  == null ? '' : edit.slug).trim().slice(0, 80);
    if (!title && !slug) return null;
    var ids = [];
    if (Array.isArray(edit.ids)) {
      edit.ids.forEach(function (id) {
        if (id == null || ids.length >= 12) return;
        var v = String(id);
        if (v && ids.indexOf(v) === -1) ids.push(v);
      });
    }
    return {
      slug:   slug,
      title:  title,
      skin:   String(edit.skin == null ? '' : edit.skin).trim().toLowerCase().slice(0, 40),
      source: String(edit.source == null ? '' : edit.source).trim().slice(0, 60),
      ids:    ids,
      setAt:  typeof edit.setAt === 'number' ? edit.setAt : Date.now()
    };
  }

  /* "The Halloween Edit \u2014 Gels" \u2192 "Halloween Edit".
     Drops the leading article and a trailing TIER qualifier (and only
     a tier qualifier \u2014 "The Halloween Edit \u2014 Neons" keeps "Neons",
     because that is a real name, not a tier restatement). The tier is
     never ambiguous at the call sites: the bar narrates one focused
     tier and the drawer renders one section per tier. */
  var EDIT_ARTICLE_RE = /^the\s+/i;
  /* 2026-09-16: a kit PRODUCT's title is "The Halloween Edit — Classic Nail
     Wraps Starter Kit" (HQ mints them so), so the full tier-kit suffix is a
     tier restatement too — without this the PDP path stamped
     "Halloween Edit — Classic Nail Wra…" on four surfaces. */
  var EDIT_TIER_SUFFIX_RE = /\s*[\u2014\u2013-]\s*(gel wraps?|gels?|press[\u2011\- ]?ons?|classic wraps?|classics?|wraps?|(?:classic|gel|press[\u2011\- ]?on)\s+(?:nail\s+wraps?|nails?)\s+starter\s+kit)\s*$/i;
  function editLabelFrom(edit) {
    if (!edit) return '';
    var t = String(edit.title || '').trim();
    if (!t) return '';
    t = t.replace(EDIT_ARTICLE_RE, '').replace(EDIT_TIER_SUFFIX_RE, '').trim();
    if (!t) return '';
    if (t.length > EDIT_LABEL_MAX) {
      t = t.slice(0, EDIT_LABEL_MAX - 1).replace(/[\s\u2014\u2013\u00b7,.;:-]+$/, '') + '\u2026';
    }
    return t;
  }

  /* TTL pruning — silently drop tiers whose items are older than the
     TTL window. Returns { state, cleared: [tier, ...] } so callers can
     emit a change event when something was actually pruned. */
  function pruneTtl(state) {
    var now = Date.now();
    var cleared = [];
    Object.keys(state.kits).forEach(function (tier) {
      var k = state.kits[tier];
      if (k.items.length === 0) return;
      if (!k.updatedAt) { k.updatedAt = now; return; }
      if (now - k.updatedAt > TTL_MS) {
        k.items = [];
        k.updatedAt = 0;
        /* The edit name belongs to the picks it prefilled — when they
           age out the kit is generic again. */
        if (KIT_TIERS.indexOf(tier) !== -1) k.edit = null;
        cleared.push(tier);
      }
    });
    /* If the active kit was pruned, drop activeKit. */
    if (state.activeKit && state.kits[state.activeKit] &&
        state.kits[state.activeKit].items.length === 0 &&
        cleared.indexOf(state.activeKit) !== -1) {
      state.activeKit = null;
    }
    return { state: state, cleared: cleared };
  }

  /* In-memory state — single source of truth for the current tab.
     Re-loaded from localStorage on construction and on `storage` events
     (cross-tab updates). Writes are immediate (sync) and persistent. */
  var memory = null;
  var memoryCustomerId = null;

  function readRaw(customerId) {
    try {
      var raw = localStorage.getItem(storageKey(customerId));
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) { return null; }
  }

  function writeRaw(customerId, state) {
    try {
      localStorage.setItem(storageKey(customerId), JSON.stringify(state));
      return true;
    } catch (e) {
      if (window && window.console) {
        console.warn('[hgn-kit-progress] localStorage write failed:', e);
      }
      return false;
    }
  }

  /* Load the current customer's state, prune TTL, cache to memory. */
  function load() {
    var cid = currentCustomerId();
    if (memory && memoryCustomerId === cid) return memory;
    var raw = readRaw(cid);
    var state = normalise(raw);
    var pruned = pruneTtl(state);
    if (pruned.cleared.length > 0) {
      writeRaw(cid, state);
      /* Defer the event until subscribe()s have run — this is called
         during init, before consumers exist. We dispatch on document
         in a microtask so any sync subscribe() inside the same script
         turn still receives the cleanup notification. */
      Promise.resolve().then(function () {
        emit({ state: clone(state), action: 'ttl-cleanup', cleared: pruned.cleared });
      });
    }
    memory = state;
    memoryCustomerId = cid;
    return memory;
  }

  function persist(action, extra) {
    var cid = currentCustomerId();
    writeRaw(cid, memory);
    var detail = Object.assign({ state: clone(memory), action: action }, extra || {});
    emit(detail);
  }

  function emit(detail) {
    try {
      document.dispatchEvent(new CustomEvent('hgn:kit:change', { detail: detail }));
    } catch (e) {}
  }

  /* ───────── Public API ───────── */

  function read() {
    var s = load();
    return clone(s);
  }

  function write(newState) {
    /* Merge into memory so we never silently drop fields. */
    var normalised = normalise(newState);
    memory = normalised;
    persist('write');
  }

  function getActiveKit() {
    var a = load().activeKit;
    /* Hide active state for a disabled tier — same reasoning as
       getFocus(). Prevents kit-bar from claiming a build is in
       progress on a kit the market has switched off. */
    if (a && !isTierEnabled(a)) return null;
    return a;
  }

  function setActiveKit(tier) {
    if (tier !== null && KIT_TIERS.indexOf(tier) === -1) return;
    var s = load();
    if (s.activeKit === tier) return;
    var prev = s.activeKit;
    s.activeKit = tier;
    /* Touch the new active tier's updatedAt so it's freshly TTL'd. */
    if (tier && s.kits[tier]) s.kits[tier].updatedAt = Date.now();
    persist('switch', { fromKit: prev, kit: tier });
  }

  /* ───────── Focus (which kit the shopper is committed to) ─────────
     Read by the side cart (renders only the focused tier's section),
     the ATC takeover (only cards matching the focused tier flip to
     "Add to Starter Kit"), and the kit-bar (shows "Building: <tier>
     · Change"). Setting focus emits `hgn:kit:focus:change`. */
  function getFocus() {
    var f = load().focus;
    /* Treat focus on a disabled tier as null. Prevents stale
       cross-market localStorage from holding focus on a kit the
       merchant has switched off for this market. */
    if (f && !isTierEnabled(f)) return null;
    return f;
  }
  function setFocus(tier) {
    if (tier !== null && KIT_TIERS.indexOf(tier) !== -1) {
      if (!isTierEnabled(tier)) return; // disabled tier — refuse silently
    } else if (tier !== null) {
      return; // invalid string — ignore
    }
    var s = load();
    if (s.focus === tier) return;
    var prev = s.focus;
    s.focus = tier;
    persist('focus', { fromFocus: prev, focus: tier });
    try {
      document.dispatchEvent(new CustomEvent('hgn:kit:focus:change', {
        detail: { from: prev, to: tier }
      }));
    } catch (e) {}
  }

  function getKit(tier) {
    var s = load();
    return s.kits[tier] ? clone(s.kits[tier]) : null;
  }

  function getItem(tier, id) {
    var s = load();
    if (!s.kits[tier]) return undefined;
    return s.kits[tier].items.find(function (it) {
      return String(it.id) === String(id);
    });
  }

  function hasItem(tier, id) {
    return Boolean(getItem(tier, id));
  }

  function addItem(tier, item) {
    if (!item || !item.id) return false;
    var s = load();
    if (!s.kits[tier]) return false;
    /* Skip if already present (caller should remove first if they want
       to re-add). */
    var existing = s.kits[tier].items.find(function (it) {
      return String(it.id) === String(item.id);
    });
    if (existing) return false;
    var prevLen = s.kits[tier].items.length;
    /* `priceCurrency` — the presentment currency `item.price` was
       captured in. Every ATC surface reads its figure from a
       `money_without_currency` attribute, i.e. a bare number with no
       currency marker at all, so without this stamp a pick made in
       CHF is indistinguishable from one made in GBP and consumers
       have to fall back to a merchant-curated worth table (which is
       what made the drawer's kit savings disagree with the basket's,
       2026-08-12). Readers MUST compare it against the currency
       that's active NOW and ignore the price when they differ. */
    var stamped = Object.assign({}, item, {
      id: String(item.id),
      addedAt: Date.now(),
      priceCurrency: String(item.priceCurrency || activePresentmentIso() || '').toUpperCase()
    });
    s.kits[tier].items.push(stamped);
    s.kits[tier].updatedAt = Date.now();
    /* Auto-promote ONLY on first-ever add (when activeKit is null).
       Subsequent adds to other tiers stay silent — the side cart
       renders every started tier as its own section, so we don't
       need to "follow attention" to the most recent tier (that was
       the legacy single-section UX). Previously: every add promoted
       its tier to active, which stole focus mid-build when a
       shopper picked from a different tier accidentally. */
    if (KIT_TIERS.indexOf(tier) !== -1 && s.activeKit == null) {
      s.activeKit = tier;
    }
    persist('add', { kit: tier, item: stamped });
    /* Detect the transition from below-minimum to at/above-minimum so
       the side cart can auto-open prompting the shopper to finish the
       kit (pick accessories). Fires once per crossing — re-removing
       and re-adding will fire again, which is desirable when a shopper
       genuinely re-completes the kit. */
    var minimum = tierMaximum(tier);
    if (KIT_TIERS.indexOf(tier) !== -1 && minimum > 0 &&
        prevLen < minimum && s.kits[tier].items.length >= minimum) {
      try {
        document.dispatchEvent(new CustomEvent('hgn:kit:reached-minimum', {
          detail: { tier: tier, kit: clone(s.kits[tier]), minimum: minimum }
        }));
      } catch (e) {}
    }
    return true;
  }

  function removeItem(tier, id) {
    var s = load();
    if (!s.kits[tier]) return false;
    var before = s.kits[tier].items.length;
    s.kits[tier].items = s.kits[tier].items.filter(function (it) {
      return String(it.id) !== String(id);
    });
    if (s.kits[tier].items.length === before) return false;
    s.kits[tier].updatedAt = Date.now();
    /* If the active kit just emptied, drop activeKit so the
       announcement bar doesn't sit in a confusing "0 picked" state. */
    if (s.activeKit === tier && s.kits[tier].items.length === 0) {
      s.activeKit = null;
    }
    persist('remove', { kit: tier, id: String(id) });
    return true;
  }

  function clearKit(tier) {
    var s = load();
    if (!s.kits[tier]) return;
    /* Always wipe items + accessories, even when the kit looks empty
       on items alone — accessories can outlive items in edge paths
       (e.g. a stale state where items got cleared but accessories
       didn't, or a snapshot/restore round-trip). Skipping the reset
       here was causing the next kit of the same tier to inherit
       previously-picked accessories — kits must always start fresh. */
    var hasItems = s.kits[tier].items && s.kits[tier].items.length > 0;
    var hasAccessories = s.kits[tier].accessories &&
      Object.keys(s.kits[tier].accessories).length > 0;
    /* A cleared kit must also forget the edit it came from \u2014 including
       the edit-only case (a curated apply that added nothing because
       everything was already picked, then a clear). */
    var hasEdit = !!s.kits[tier].edit;
    if (!hasItems && !hasAccessories && !hasEdit && s.activeKit !== tier) return;
    s.kits[tier].items = [];
    s.kits[tier].updatedAt = 0;
    if (KIT_TIERS.indexOf(tier) !== -1) {
      s.kits[tier].accessories = {};
      s.kits[tier].edit = null;
    }
    if (s.activeKit === tier) s.activeKit = null;
    persist('clear', { kit: tier });
  }

  function clearAll() {
    memory = emptyState();
    clearManifest();
    persist('clear-all');
  }

  /* ───────── Curated edit: set / read / clear ─────────
     Written by the curated-kit apply path (hgn-curated-kit-card.liquid)
     the moment a kit is prefilled from an edit. Nothing else writes it;
     clearKit / clearAll / the TTL sweep are the only things that
     remove it. Idempotent: re-applying the same edit is a no-op, so a
     double-tap does not emit a change event or re-render anything. */
  function getEdit(tier) {
    var s = load();
    if (!s.kits[tier] || !s.kits[tier].edit) return null;
    return clone(s.kits[tier].edit);
  }

  function setEdit(tier, edit) {
    if (KIT_TIERS.indexOf(tier) === -1) return false;
    var s = load();
    if (!s.kits[tier]) return false;
    var next = sanitiseEdit(edit);
    var prev = s.kits[tier].edit || null;
    /* Compare on identity fields only \u2014 `setAt` changes every call
       and must not make an otherwise-identical re-apply look new. */
    var same = (!prev && !next) || (prev && next &&
      prev.slug === next.slug && prev.title === next.title &&
      prev.ids.join(',') === next.ids.join(','));
    if (same) return true;
    s.kits[tier].edit = next;
    persist('edit', { kit: tier, edit: next ? clone(next) : null });
    return true;
  }

  function clearEdit(tier) { return setEdit(tier, null); }

  /* The generic tier name \u2014 merchant copy wins, built-in is the floor. */
  function genericKitLabel(tier) {
    var key = TIER_LABEL_COPY_KEY[tier];
    if (key) {
      try {
        var v = (window.HGN_KIT_BAR_COPY || {})[key];
        if (v != null && String(v).trim() !== '') return String(v).trim();
      } catch (e) {}
    }
    return TIER_LABEL[tier] || 'Starter Kit';
  }

  /* The edit name IF this tier is still meaningfully "their Halloween
     Edit", else ''. The name PERSISTS through swaps and additions \u2014 a
     shopper who changes one design still has the edit they started
     from. It drops the moment NONE of the edit's original designs are
     still picked (including an emptied kit): at that point nothing of
     the edit remains and the generic tier name is the honest one. */
  function kitEditLabel(tier) {
    var s = load();
    var k = s.kits[tier];
    if (!k || !k.edit) return '';
    var label = editLabelFrom(k.edit);
    if (!label) return '';
    var ids = k.edit.ids || [];
    if (!ids.length) return '';
    var items = k.items || [];
    for (var i = 0; i < items.length; i++) {
      if (ids.indexOf(String(items[i].id)) !== -1) return label;
    }
    return '';
  }

  /* THE naming helper. Every surface that names a kit calls this and
     nothing else \u2014 "Halloween Edit" when the kit came from one,
     "Classic Wraps Kit" otherwise. */
  function kitLabel(tier) {
    return kitEditLabel(tier) || genericKitLabel(tier);
  }

  /* ───────── Accessories ─────────
     Each kit tier can carry slot-keyed accessory selections (top coat,
     UV lamp, gift bag, optional press-on upsells). Stored as
     `kits[tier].accessories[slot] = { id, variantId, handle, title,
     image, price, addedAt }`. Slot names per tier are validated
     against ACCESSORY_SLOTS so a typo can't silently store garbage. */

  function getAccessory(tier, slot) {
    var s = load();
    if (!s.kits[tier] || !s.kits[tier].accessories) return undefined;
    return s.kits[tier].accessories[slot];
  }

  function getAccessories(tier) {
    var s = load();
    if (!s.kits[tier]) return {};
    return clone(s.kits[tier].accessories || {});
  }

  function setAccessory(tier, slot, value) {
    if (KIT_TIERS.indexOf(tier) === -1) return false;
    var allowed = ACCESSORY_SLOTS[tier] || [];
    if (allowed.indexOf(slot) === -1) return false;
    if (!value || !value.id) return false;
    var s = load();
    if (!s.kits[tier].accessories) s.kits[tier].accessories = {};
    var stamped = Object.assign({}, value, {
      id:    String(value.id),
      addedAt: Date.now()
    });
    s.kits[tier].accessories[slot] = stamped;
    s.kits[tier].updatedAt = Date.now();
    persist('accessory-set', { kit: tier, slot: slot, value: stamped });
    return true;
  }

  function clearAccessory(tier, slot) {
    if (KIT_TIERS.indexOf(tier) === -1) return false;
    var s = load();
    if (!s.kits[tier].accessories) return false;
    if (!(slot in s.kits[tier].accessories)) return false;
    delete s.kits[tier].accessories[slot];
    s.kits[tier].updatedAt = Date.now();
    persist('accessory-clear', { kit: tier, slot: slot });
    return true;
  }

  /* True iff every required accessory slot for this tier has a
     selection. Optional slots (press-on tabs / glue) DO NOT count
     toward "complete" — they're upsells, not requirements. */
  var REQUIRED_ACCESSORY_SLOTS = {
    classic:     ['topCoat', 'giftBag'],
    gels:        ['uvLamp', 'giftBag'],
    'press-ons': ['remover', 'giftBag']
  };
  function accessoriesComplete(tier) {
    /* requiredSlotsFor, not the raw table — a gift slot with nothing
       left to offer is not something the shopper can ever fill, so it
       must not block completion. */
    var required = requiredSlotsFor(tier);
    if (!required) return true;
    var bag = getAccessories(tier) || {};
    for (var i = 0; i < required.length; i++) {
      if (!bag[required[i]] || !bag[required[i]].id) return false;
    }
    return true;
  }

  /* Tiers with parked items (have items, but not the active one). Used
     by the announcement bar drawer to surface a "you also have a
     {Tier} kit started" pill. Excludes accessories. */
  function getOtherStarted() {
    var s = load();
    return KIT_TIERS.filter(function (tier) {
      return tier !== s.activeKit && s.kits[tier].items.length > 0;
    });
  }

  /* Sign-in merge. Mirrors the wishlist's pattern: if a guest built a
     kit before signing in, merge those items into the customer's kit
     additively (no overwrite — items the customer already has stay
     unchanged; new ones are appended). The anon storage is wiped
     after merge so we don't double-merge on subsequent loads. */
  function syncOnSignIn(customerId) {
    if (!customerId || customerId === 'anon') return;

    var anonRaw = readRaw('anon');
    if (!anonRaw) return;
    var anonState = normalise(anonRaw);

    /* Anything to merge? */
    var anonHasItems = KIT_TIERS.some(function (t) {
      return anonState.kits[t].items.length > 0;
    }) || anonState.kits.accessories.items.length > 0;
    if (!anonHasItems) {
      try { localStorage.removeItem(storageKey('anon')); } catch (e) {}
      return;
    }

    var customerState = normalise(readRaw(customerId));
    var now = Date.now();
    var merged = false;

    Object.keys(customerState.kits).forEach(function (tier) {
      var custItems = customerState.kits[tier].items;
      var anonItems = anonState.kits[tier].items;
      var seen = {};
      custItems.forEach(function (it) { seen[String(it.id)] = true; });
      anonItems.forEach(function (it) {
        if (!seen[String(it.id)]) {
          custItems.push(it);
          merged = true;
        }
      });
      if (anonItems.length > 0) {
        customerState.kits[tier].updatedAt = now;
      }
      /* Adopt the guest's edit name only when the signed-in kit has
         none of its own \u2014 never overwrite a curated kit the customer
         already started on another device. */
      if (KIT_TIERS.indexOf(tier) !== -1 &&
          !customerState.kits[tier].edit && anonState.kits[tier].edit) {
        customerState.kits[tier].edit = anonState.kits[tier].edit;
        merged = true;
      }
    });

    /* Adopt the guest's active kit only if the customer didn't already
       have one going. */
    if (!customerState.activeKit && anonState.activeKit) {
      customerState.activeKit = anonState.activeKit;
    }

    if (merged || customerState.activeKit !== (readRaw(customerId) || {}).activeKit) {
      writeRaw(customerId, customerState);
    }
    try { localStorage.removeItem(storageKey('anon')); } catch (e) {}

    /* Force a reload of memory under the customer key so subsequent
       reads reflect the merged state. */
    memory = null;
    memoryCustomerId = null;
    load();

    if (merged) emit({ state: clone(memory), action: 'merge' });
  }

  /* ───────── Kit Build Mode (item #40 — the on/off switch) ─────────

     The site-wide on/off switch that decides whether the shopper is in
     "build a starter kit" mode at all. When ON: kit-bar visible, ATC
     takeover live, eligible cart items get migrated INTO the kit. When
     OFF: kit-bar hidden, normal site behaviour, picks get migrated OUT
     of the kit and INTO the cart at full price.

     The switch is the single source of truth — it's what drives
     `body.hgn-kit-active`. The kit's `activeKit` pointer is now a
     *passive* indicator of which tier is being built, not the trigger
     for kit-mode itself.

     Storage: `hgn-kit-build-mode:<customerId>` ('on' / 'off'). Per
     customer so signed-in shoppers can have their preference persist.
     Default: 'off'.

     The "items never lost between modes" rule: every flip routes
     through migration. ON→OFF moves all picks (across all tiers) to
     the cart at full price. OFF→ON scans the cart, ingests up to each
     eligible tier's max (excess stays in cart), removes ingested lines.

     The cart is the backstop: if migration fails partway, picks remain
     on whichever side they ended up. We never destructively clear the
     kit before the cart-add succeeds. */

  var KIT_BUILD_MODE_PREFIX = 'hgn-kit-build-mode:';

  function buildModeStorageKey(customerId) {
    return KIT_BUILD_MODE_PREFIX + (customerId || 'anon');
  }

  function getKitBuildMode() {
    try {
      var raw = localStorage.getItem(buildModeStorageKey(currentCustomerId()));
      return raw === 'on' ? 'on' : 'off';
    } catch (e) { return 'off'; }
  }

  function writeKitBuildMode(state) {
    try {
      localStorage.setItem(buildModeStorageKey(currentCustomerId()), state === 'on' ? 'on' : 'off');
      return true;
    } catch (e) { return false; }
  }

  function applyBuildModeBodyClass(state) {
    if (!document || !document.body) return;
    document.body.classList.toggle('hgn-kit-active', state === 'on');
    /* Legacy collection-chrome flag — kept in sync so existing CSS
       selectors / JS readers that haven't been migrated yet still
       reflect the switch. New code should read `hgn-kit-active`. */
    document.body.classList.toggle('hgn-coll-kit-mode', state === 'on');
  }

  /* JS-side mirror of the kit-eligibility predicate in
     redesigned/snippets/card-product.liquid (lines 58-64). Multi-packs
     are pre-discounted bundles; starter-kit products & accessories
     can't be ingredients in a kit. Cart lines that are themselves
     part of an existing in-cart bundle (carry `_bundle_id` /
     `_bundle_type` line properties from a previous build) are also
     skipped — moving an already-built kit's items into a NEW kit
     would orphan the bundle and double-charge the shopper. Used
     when scanning the cart for items to migrate INTO the kit on
     switch-on. */
  function isCartLineKitEligible(line) {
    if (!line) return false;
    var ptype  = String(line.product_type || line.productType || '').toLowerCase();
    var handle = String(line.handle || line.product_handle || '').toLowerCase();
    var title  = String(line.product_title || line.title || '').toLowerCase();
    /* Built-bundle lines: anything carrying `_bundle_id`, `_bundle_type`,
       or `Box ID` line property is already part of a kit in the cart. */
    var props = (line.properties && typeof line.properties === 'object') ? line.properties : {};
    if (props._bundle_id || props['_bundle_id'] ||
        props._bundle_type || props['_bundle_type'] ||
        props['Box ID'] || props['Bundle']) {
      return false;
    }
    if (ptype.indexOf('accessor')   !== -1) return false;
    if (ptype.indexOf('starter kit') !== -1) return false;
    if (ptype.indexOf('starter-kit') !== -1) return false;
    if (handle.indexOf('starter-kit') !== -1) return false;
    if (handle.indexOf('starter_kit') !== -1) return false;
    if (title.indexOf('starter kit') !== -1) return false;
    if (title.indexOf('pack') !== -1) return false;
    /* "Matching Tips & Toes" sets are curated multi-design pairings,
       not a single-design ingredient. Both the `&` and `and` title
       variants share the `matching tips` prefix. */
    if (title.indexOf('matching tips') !== -1) return false;
    return true;
  }

  /* Map a cart line's product_type to a kit tier. Mirrors the
     wishlist tier inference in card-product.liquid (lines 42-48). */
  function inferTierFromCartLine(line) {
    if (!line) return null;
    var ptype = String(line.product_type || line.productType || '').toLowerCase();
    if (ptype.indexOf('gel')   !== -1) return 'gels';
    if (ptype.indexOf('press') !== -1) return 'press-ons';
    /* Default to classic for non-gel / non-press-on wraps. If the type
       is genuinely unknown (e.g. accessory caught earlier), the
       eligibility check above should've already excluded it. */
    return 'classic';
  }

  /* Variant resolution helper — duplicated from hgn-kit-bar.liquid's
     recovery loop so kit-progress can run the migration self-contained
     without a dependency on the kit-bar being mounted. Each kit pick
     stores a handle but no variantId; we hit `/products/<handle>.js`
     to grab the first available variant. */
  function resolveVariantForKitItem(item) {
    if (!item) return Promise.resolve(null);
    if (item.variantId) {
      return Promise.resolve({ id: parseInt(item.variantId, 10), quantity: 1 });
    }
    if (!item.handle) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(item.handle) + '.js', {
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) return null;
      return res.json();
    }).then(function (product) {
      if (!product || !Array.isArray(product.variants) || product.variants.length === 0) return null;
      var variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      return { id: parseInt(variant.id, 10), quantity: 1 };
    }).catch(function () { return null; });
  }

  /* Per-tier minimums — match window.HGN.STARTER_KIT_MINIMUMS if set,
     otherwise fall back to canonical defaults. Used as the *upper
     bound* when ingesting from cart on switch-on. */
  function tierMaximum(tier) {
    var m = (window.HGN && window.HGN.STARTER_KIT_MINIMUMS) ||
      { classic: 5, gels: 3, 'press-ons': 3 };
    return m[tier] || 0;
  }

  /* Count picks across all tiers — used by the confirm prompts. */
  function totalKitPicks() {
    var s = load();
    var n = 0;
    KIT_TIERS.forEach(function (t) {
      n += (s.kits[t] && s.kits[t].items) ? s.kits[t].items.length : 0;
    });
    return n;
  }

  /* Preview the OFF→ON migration without mutating anything. Returns
     `{ eligibleCount, byTier, overflowByTier, lines }` where lines are
     the cart lines we'd actually move (already capped at tier max). */
  function previewCartToKits(cart) {
    var byTier = { classic: [], gels: [], 'press-ons': [] };
    var overflowByTier = { classic: 0, gels: 0, 'press-ons': 0 };
    if (!cart || !Array.isArray(cart.items)) {
      return { eligibleCount: 0, byTier: byTier, overflowByTier: overflowByTier, lines: [] };
    }
    var s = load();
    cart.items.forEach(function (line) {
      if (!isCartLineKitEligible(line)) return;
      var tier = inferTierFromCartLine(line);
      if (!tier || KIT_TIERS.indexOf(tier) === -1) return;
      /* Count what the kit already holds for that tier — we top up
         to the tier max but never overshoot. */
      var alreadyIn = (s.kits[tier].items || []).length;
      var spare = Math.max(0, tierMaximum(tier) - alreadyIn - byTier[tier].length);
      var qty = Math.max(1, parseInt(line.quantity, 10) || 1);
      /* Each line counts as ONE pick (designs aren't bought in
         multiples within a kit). If the line has qty>1, only one of
         them migrates; the rest stay in cart so the shopper doesn't
         lose duplicate purchases. */
      if (spare > 0) {
        byTier[tier].push(line);
      } else {
        overflowByTier[tier] += 1;
      }
      /* Suppress unused warning */
      if (qty > 1) { /* extra qty stays in cart by design */ }
    });
    var lines = [].concat(byTier.classic, byTier.gels, byTier['press-ons']);
    return {
      eligibleCount: lines.length,
      byTier: byTier,
      overflowByTier: overflowByTier,
      lines: lines
    };
  }

  /* OFF→ON migration. Fetches cart, picks eligible lines (capped at
     tier max), adds them to kitProgress, then removes those lines
     from the cart. Returns a summary the caller can toast.

     `opts.focus` (optional, tier string) — when set, only cart lines
     matching that tier are migrated. Used by the focus-modal flow:
     a shopper who picked "Classic" wants their Gel/Press-On items
     to stay in the cart untouched. When omitted/null, all eligible
     tiers migrate (legacy "haven't decided" behaviour). */
  function migrateCartToKits(opts) {
    opts = opts || {};
    var focusTier = (opts.focus && KIT_TIERS.indexOf(opts.focus) !== -1) ? opts.focus : null;
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (!cart) return { ok: false, eligibleCount: 0, moved: 0 };
        var preview = previewCartToKits(cart);
        /* Filter to just the focused tier when requested. The
           pre-filter `preview.byTier` is keyed on tier name, so we
           rebuild the lines list from just that tier's array. */
        if (focusTier) {
          var focusLines = preview.byTier[focusTier] || [];
          preview = {
            eligibleCount: focusLines.length,
            byTier: (function () {
              var b = { classic: [], gels: [], 'press-ons': [] };
              b[focusTier] = focusLines;
              return b;
            })(),
            overflowByTier: preview.overflowByTier,
            lines: focusLines
          };
        }
        if (preview.eligibleCount === 0) {
          return { ok: true, eligibleCount: 0, moved: 0, byTier: preview.byTier };
        }
        /* Add picks to kitProgress first (local-only — fast). The
           `_silent` flag suppresses individual change events; we
           emit one summary event at the end so subscribers don't
           thrash. */
        var addedByTier = { classic: 0, gels: 0, 'press-ons': 0 };
        var biggestTier = null;
        var biggestCount = 0;
        Object.keys(preview.byTier).forEach(function (tier) {
          preview.byTier[tier].forEach(function (line) {
            /* Variant ID is on the cart line directly — use it so we
               don't have to refetch /products/<handle>.js. */
            var item = {
              id:        String(line.product_id || line.id),
              handle:    line.handle || line.product_handle,
              title:     line.product_title || line.title,
              image:     line.image || line.featured_image,
              price:     (typeof line.price === 'number') ? line.price / 100 : null,
              variantId: line.variant_id || line.id
            };
            var added = addItem(tier, item);
            if (added) addedByTier[tier] += 1;
          });
          if (addedByTier[tier] > biggestCount) {
            biggestCount = addedByTier[tier];
            biggestTier = tier;
          }
        });

        if (biggestTier) setActiveKit(biggestTier);

        /* Remove the migrated lines from the cart via /cart/update.js
           (atomic, key-addressed). ONE unit per line migrates into the
           kit — a line with qty>1 keeps the remainder in cart, exactly
           as the eligibility preview above promises ("the rest stay in
           cart so the shopper doesn't lose duplicate purchases").
           Writing 0 here used to delete the whole line: qty 3 → 1 pick
           + 2 units silently destroyed (audit item B2). */
        var updates = {};
        preview.lines.forEach(function (line) {
          if (!line.key) return;
          var lineQty = Math.max(1, parseInt(line.quantity, 10) || 1);
          updates[line.key] = lineQty - 1;
        });
        if (Object.keys(updates).length === 0) {
          emit({ state: clone(memory), action: 'cart-to-kit-migrated', byTier: addedByTier });
          return { ok: true, eligibleCount: preview.eligibleCount, moved: preview.eligibleCount, byTier: addedByTier };
        }
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (res) {
          if (!res.ok) {
            /* Cart removal failed — items are now in BOTH kit and
               cart. To keep the cart-as-backstop invariant intact,
               we roll back the kit additions so the items live in
               the cart only. */
            Object.keys(addedByTier).forEach(function (tier) {
              preview.byTier[tier].forEach(function (line) {
                removeItem(tier, String(line.product_id || line.id));
              });
            });
            throw new Error('cart-update-failed');
          }
          /* Notify side cart / announcement bar / anywhere else that
             tracks cart state. */
          try {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
          } catch (e) {}
          emit({ state: clone(memory), action: 'cart-to-kit-migrated', byTier: addedByTier });
          return { ok: true, eligibleCount: preview.eligibleCount, moved: preview.eligibleCount, byTier: addedByTier };
        });
      })
      .catch(function (err) {
        if (window && window.console) {
          console.warn('[hgn-kit-progress] cart→kit migration failed:', err);
        }
        return { ok: false, eligibleCount: 0, moved: 0, error: err && err.message };
      });
  }

  /* ON→OFF migration. Walks every tier with picks, resolves variants,
     bulk-adds to cart, then clears the kits. Adapted from
     hgn-kit-bar.liquid:2325-2451 (the Recovery loop) so it's available
     anywhere kit-progress is loaded — not only when the kit-bar is
     mounted. Returns `{ ok, moved, failed }`. */
  function migrateKitsToCart() {
    var s = load();
    /* Flatten every tier's items into a single resolution + add pass.
       Each pick goes to the cart at full price, regardless of which
       tier it was building toward. */
    var allPicks = [];
    KIT_TIERS.forEach(function (tier) {
      (s.kits[tier].items || []).forEach(function (item) {
        allPicks.push({ tier: tier, item: item });
      });
    });
    if (allPicks.length === 0) {
      return Promise.resolve({ ok: true, moved: 0, failed: 0 });
    }
    return Promise.all(allPicks.map(function (p) {
      return resolveVariantForKitItem(p.item).then(function (variant) {
        return variant ? { tier: p.tier, item: p.item, variant: variant } : null;
      });
    })).then(function (resolved) {
      var ok = resolved.filter(function (r) { return r && r.variant && r.variant.id; });
      var failed = resolved.length - ok.length;
      if (ok.length === 0) {
        throw new Error('no-resolvable-variants');
      }
      /* Symmetric unit accounting (2026-07-12, follows from audit B2):
         toggle-ON removes EXACTLY ONE unit per migrated line, so
         toggle-OFF must add exactly one unit per pick — stacking onto
         an existing line of the same variant is CORRECT (the shopper's
         other units are the qty>1 remainder ON deliberately left, or a
         previous kit's transfer they also chose). The old pre-flight
         dedupe ("variant already in cart → skip the add") was designed
         for the pre-B2 world where ON consumed whole lines; after B2
         it silently swallowed one unit of intent on every ON→OFF round
         trip with a multi-qty line (verified live: 3 units in, 2 out). */
      return (function () {
        var toAdd = ok;
        var manifest = readManifest();
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: toAdd.map(function (r) { return r.variant; }) })
        }).then(function (res) {
          if (!res.ok) throw new Error('cart-add-failed');
          return res.json();
        }).then(function (cartAddResp) {
        /* Cart-add succeeded. Write manifest entries for the newly
           added lines — /cart/add.js returns items in request order,
           so position N maps to toAdd[N]. When a pick stacked onto an
           existing line of the same variant, the returned line key is
           that line's key — the manifest maps it to this pick (per-line
           granularity; one entry per key). */
        var addedItems = (cartAddResp && Array.isArray(cartAddResp.items)) ? cartAddResp.items : [];
        addedItems.forEach(function (line, i) {
          var src = toAdd[i];
          if (!line || !line.key || !src) return;
          manifest[line.key] = {
            tier:   src.tier,
            itemId: String(src.item.id)
          };
        });
        writeManifest(manifest);
        /* Kit memory is intentionally PRESERVED so toggling build mode
           back ON restores the picks. If the shopper removes a cart
           line that came from a kit, the side cart calls
           `pruneManifestForLineKey` which drops the pick + manifest
           entry in lockstep — that's the path that evicts kit memory. */
        try {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (e) {}
        emit({ state: clone(memory), action: 'kit-to-cart-migrated', moved: ok.length, failed: failed });
        return { ok: true, moved: ok.length, failed: failed };
        });
      })();
    }).catch(function (err) {
      if (window && window.console) {
        console.warn('[hgn-kit-progress] kit→cart migration failed:', err);
      }
      return { ok: false, moved: 0, failed: allPicks.length, error: err && err.message };
    });
  }

  /* The main switch handler. Idempotent — calling with the current
     state is a no-op. Always returns a Promise so callers can await
     migration completion before re-rendering UI.

     opts.skipMigration   → flip the flag without moving items (escape
                             hatch for tests / restore flows).
     opts.skipFocusModal  → don't open the focus picker on toggle ON
                             (used when caller is supplying focus
                             directly via opts.focus, e.g. UTM deep
                             link, or when the caller is itself the
                             modal flow).
     opts.focus           → tier string ('classic'|'gels'|'press-ons')
                             or null/undefined. When set, applied
                             before migration so the migration filters
                             to that tier. When null/undefined and the
                             modal isn't skipped, we open the focus
                             modal first and re-enter setKitBuildMode
                             with the picked focus.
     opts.source          → label propagated to the change event for
                             telemetry / debugging. */
  function setKitBuildMode(target, opts) {
    opts = opts || {};
    var next = (target === 'on') ? 'on' : 'off';
    var current = getKitBuildMode();
    if (next === current) {
      return Promise.resolve({ ok: true, changed: false, mode: current });
    }
    /* Toggle ON with no focus declared and modal not skipped → open
       the focus modal first. The modal's "haven't decided" path
       resolves with focus=null (legacy behaviour, every tier
       eligible); a tier choice resolves with that tier. We then
       re-enter setKitBuildMode with `skipFocusModal: true` and the
       chosen focus so migration runs filtered to it. */
    if (next === 'on' && !opts.skipMigration && !opts.skipFocusModal &&
        typeof opts.focus === 'undefined' &&
        window.HGN && window.HGN.kitFocusModal &&
        typeof window.HGN.kitFocusModal.show === 'function') {
      return window.HGN.kitFocusModal.show({ source: opts.source || 'set-build-mode' })
        .then(function (picked) {
          if (picked === '__cancel__') {
            return { ok: true, changed: false, mode: current, cancelled: true };
          }
          return setKitBuildMode('on', {
            skipFocusModal: true,
            focus:          picked === 'any' ? null : picked,
            source:         opts.source || 'focus-modal'
          });
        });
    }
    /* Persist the build-mode flag UPFRONT when toggling ON with focus
       supplied. The focus event listener (collection-chrome) may
       redirect to a canonical collection — if we wait for migration
       to complete before writing, the destination page loads with
       build-mode still off and the toggle has to be flipped again.
       Writing first means the destination always knows kits are on.
       Toggle OFF stays bottom-of-function so a failed kit→cart move
       leaves the flag intact (cart-as-backstop). */
    if (next === 'on' && typeof opts.focus !== 'undefined') {
      writeKitBuildMode('on');
      applyBuildModeBodyClass('on');
    }
    /* Apply focus BEFORE migration so the migration runs filtered. */
    if (next === 'on' && typeof opts.focus !== 'undefined') {
      setFocus(opts.focus); // null is allowed = "haven't decided"
    }
    var migration = Promise.resolve({ ok: true, moved: 0 });
    if (!opts.skipMigration) {
      if (next === 'off') {
        migration = migrateKitsToCart();
        /* NOTE: focus is cleared in the success path below — clearing
           it here (pre-settle) used to lose the shopper's focus even
           when a failed migration kept build mode ON. */
      } else {
        migration = migrateCartToKits({ focus: getFocus() });
      }
    }
    return migration.then(function (result) {
      /* Cart-as-backstop invariant (comment above the flag-write
         ordering): a TOTALLY failed kit→cart migration (ok:false =
         nothing moved) must NOT flip the mode off — every kit surface
         is mode-gated, so flipping off would hide picks that are now
         in neither the cart nor any visible UI. Keep mode + focus,
         tell subscribers (kit-bar shows an inline retry error), and
         report failure to the caller. Partial failures (ok:true,
         failed>0) proceed: moved picks are in cart, unresolved picks
         stay in kit memory for the next toggle ON. ON-migration
         failures are non-destructive (lines stay in cart) so the flip
         proceeds regardless. */
      if (next === 'off' && !opts.skipMigration && result && result.ok === false) {
        var blockedDetail = {
          state:     clone(memory),
          action:    'build-mode-blocked',
          from:      current,
          to:        next,
          migration: result || null,
          source:    opts.source || null
        };
        try {
          document.dispatchEvent(new CustomEvent('hgn:kit-build-mode:blocked', { detail: blockedDetail }));
        } catch (e) {}
        return Object.assign({ ok: false, changed: false, mode: current }, { migration: result });
      }
      if (next === 'off') {
        /* Toggle OFF clears focus — next toggle ON will re-prompt. */
        setFocus(null);
      }
      writeKitBuildMode(next);
      applyBuildModeBodyClass(next);
      var detail = {
        state:     clone(memory),
        action:    'build-mode',
        from:      current,
        to:        next,
        migration: result || null,
        source:    opts.source || null
      };
      try {
        document.dispatchEvent(new CustomEvent('hgn:kit-build-mode:change', { detail: detail }));
      } catch (e) {}
      /* Re-emit on the kit-change channel too so existing kit-bar /
         collection-chrome subscribers re-render without needing a
         second listener. */
      emit(detail);
      return Object.assign({ ok: true, changed: true, mode: next }, { migration: result });
    });
  }

  /* Apply the body class on initial load so any page lands with the
     correct kit-active state without waiting for a flip. */
  applyBuildModeBodyClass(getKitBuildMode());

  /* Subscribe / unsubscribe sugar — thin wrapper around the document
     event. Returns an unsubscribe function so callers can clean up
     without holding the original handler reference. */
  function subscribe(handler) {
    if (typeof handler !== 'function') return function () {};
    var wrapped = function (e) { handler(e.detail || {}); };
    document.addEventListener('hgn:kit:change', wrapped);
    return function () { document.removeEventListener('hgn:kit:change', wrapped); };
  }

  /* Cross-tab sync: when another tab updates the same key, re-load
     memory and emit. Lets the announcement-bar drawer in tab A reflect
     a pick made in tab B. */
  window.addEventListener('storage', function (e) {
    if (!e.key) return;
    var cid = currentCustomerId();
    if (e.key !== storageKey(cid)) return;
    memory = null;
    memoryCustomerId = null;
    var s = load();
    emit({ state: clone(s), action: 'storage' });
  });

  /* Initial load — primes memory and runs TTL cleanup. */
  load();

  /* ───────── Canonical kit-savings claim (audit 2026-08-12) ─────────
     The theme was advertising four different kit savings at once —
     "up to 37%" (side cart empty state), "UP TO 40% OFF" (collection
     kit banner), "typically a 25-37% saving" (how-it-works modal) and
     a live-computed 38% in the drawer — because every surface carried
     its own hardcoded number. These helpers are the ONE source each
     of those claims now reads.

     Derivation, best-available first:
       1. `window.HGN.computeProjectedKitMath(tier, null)` — the real
          full-kit projection for THIS market (`.local.savingsPct` on
          overlay markets, `.savingsPct` otherwise), taken across the
          tiers this market actually offers (getEnabledTiers, so a
          switched-off tier can't inflate the claim). Same helper the
          selector's Mode-A badge and the side cart's pricing block
          already use, so no two surfaces can disagree. FLOORED, never
          rounded up — a claim we can't substantiate is worse than a
          modest one.
       2. `window.HGN_KIT_SAVINGS_CEILING_PCT` — merchant fallback from
          the announcement bar's kit SSoT. Covers the window before the
          side cart's kit IIFE has installed computeProjectedKitMath.
       3. 37 — last resort; the approved UK classic figure
          (KIT-PRICING-2026-07.md).

     `range.low` is the WORST-saving enabled tier, so the
     how-it-works modal's "typically a X-Y% saving" line is derived
     rather than guessed. */
  var SAVINGS_CEILING_FALLBACK = 37;
  function kitSavingsRangePct() {
    var low = 0, high = 0;
    try {
      var fn = window.HGN && window.HGN.computeProjectedKitMath;
      if (typeof fn === 'function') {
        getEnabledTiers().forEach(function (tier) {
          var math = fn(tier, null);
          if (!math) return;
          var raw = (math.local && typeof math.local.savingsPct === 'number')
            ? math.local.savingsPct
            : math.savingsPct;
          if (typeof raw !== 'number' || !isFinite(raw)) return;
          var pct = Math.floor(raw);
          if (pct <= 0) return;
          if (!high || pct > high) high = pct;
          if (!low  || pct < low)  low  = pct;
        });
      }
    } catch (e) { low = 0; high = 0; }
    if (!high) {
      var cfg = parseInt(window.HGN_KIT_SAVINGS_CEILING_PCT, 10);
      high = (isFinite(cfg) && cfg > 0) ? cfg : SAVINGS_CEILING_FALLBACK;
    }
    if (!low || low > high) low = high;
    return { low: low, high: high };
  }
  function kitSavingsCeilingPct() { return kitSavingsRangePct().high; }

  /* Copy filler for JS-built strings — `{savingsPct}` becomes the
     ceiling, `{savingsPctLow}` the range floor. Mirrors the existing
     `resolveShippingTokens` pattern in hgn-kit-build-toggle. No-op on
     strings without a token, so it is safe to wrap ANY copyOr()
     result (including merchant copy that hardcodes its own number —
     that stays untouched and is a customizer edit, not a code fix). */
  function fillSavingsTokens(str) {
    if (str == null) return str;
    var s = String(str);
    if (s.indexOf('{savingsPct') === -1) return s;
    var r = kitSavingsRangePct();
    return s.replace(/\{savingsPctLow\}/g, String(r.low))
            .replace(/\{savingsPct\}/g, String(r.high));
  }

  /* SSR placeholder painter. Liquid templates ship the fallback number
     INSIDE the span (`save up to <span data-hgn-savings-pct>37</span>%`)
     so there's never a flash of raw token, and this pass corrects it to
     the market's real figure once the kit math is available. */
  function paintSavingsPct(root) {
    var pct = String(kitSavingsCeilingPct());
    var scope = root || document;
    try {
      var nodes = scope.querySelectorAll('[data-hgn-savings-pct]');
      Array.prototype.forEach.call(nodes, function (el) {
        if (el.textContent !== pct) el.textContent = pct;
      });
    } catch (e) {}
  }

  window.HGN = window.HGN || {};
  window.HGN.kitSavingsRangePct   = kitSavingsRangePct;
  window.HGN.kitSavingsCeilingPct = kitSavingsCeilingPct;
  window.HGN.fillSavingsTokens    = fillSavingsTokens;
  window.HGN.paintSavingsPct      = paintSavingsPct;
  window.HGN.kitProgress = {
    read:                read,
    write:               write,
    getActiveKit:        getActiveKit,
    setActiveKit:        setActiveKit,
    getKit:              getKit,
    getItem:             getItem,
    hasItem:             hasItem,
    addItem:             addItem,
    removeItem:          removeItem,
    clearKit:            clearKit,
    clearAll:            clearAll,
    /* Curation-aware kit naming (KIT-BUILD.md §11h) */
    getEdit:             getEdit,
    setEdit:             setEdit,
    clearEdit:           clearEdit,
    kitLabel:            kitLabel,
    kitEditLabel:        kitEditLabel,
    genericKitLabel:     genericKitLabel,
    pruneManifestForLineKey: pruneManifestForLineKey,
    getFocus:            getFocus,
    setFocus:            setFocus,
    getOtherStarted:     getOtherStarted,
    getAccessory:        getAccessory,
    getAccessories:      getAccessories,
    setAccessory:        setAccessory,
    clearAccessory:      clearAccessory,
    accessoriesComplete: accessoriesComplete,
    subscribe:           subscribe,
    syncOnSignIn:        syncOnSignIn,
    /* Kit Build Mode (item #40) — the on/off switch */
    getKitBuildMode:     getKitBuildMode,
    setKitBuildMode:     setKitBuildMode,
    previewCartToKits:   previewCartToKits,
    isCartLineKitEligible: isCartLineKitEligible,
    inferTierFromCartLine: inferTierFromCartLine,
    totalKitPicks:       totalKitPicks,
    tierMaximum:         tierMaximum,
    ACCESSORY_SLOTS:     JSON.parse(JSON.stringify(ACCESSORY_SLOTS)),
    requiredSlotsFor:    requiredSlotsFor,
    slotHasOptions:      slotHasOptions,
    pruneUnavailableGiftPicks: pruneUnavailableGiftPicks,
    GIFT_SLOTS:          GIFT_SLOTS.slice(),
    KIT_TIERS:           KIT_TIERS.slice(),
    isTierEnabled:       isTierEnabled,
    getEnabledTiers:     getEnabledTiers,
    SCHEMA_VERSION:      SCHEMA_VERSION
  };

  /* REQUIRED_ACCESSORY_SLOTS is a GETTER, not the static clone it used
     to be. Nine call sites across the side cart, kit bar and telemetry
     read `kp.REQUIRED_ACCESSORY_SLOTS[tier]`; routing them all through
     requiredSlotsFor() here means gift-slot degradation is correct
     everywhere at once, with no chance of missing a surface. Recomputes
     per access (a filter over ≤4 strings — free) so it always reflects
     the current broadcast, including a restock mid-session. */
  Object.defineProperty(window.HGN.kitProgress, 'REQUIRED_ACCESSORY_SLOTS', {
    enumerable: true,
    get: function () {
      var out = {};
      KIT_TIERS.forEach(function (tier) { out[tier] = requiredSlotsFor(tier); });
      return out;
    }
  });

  /* Prune dead gift picks once the announcement broadcast is on the
     page. hgn-kit-progress renders AHEAD of the announcement section,
     so at IIFE time HGN_KIT_ACCESSORIES is usually still unset and the
     prune would no-op forever if we only tried once. Fire at every
     point the broadcast could plausibly have landed — immediately,
     at DOM ready, and at window load. Each pass is idempotent (it only
     clears what the broadcast CONFIRMS is gone), so re-running is free.

     This is belt-and-braces, not the primary guard: the authoritative
     protection is verifyAccessoriesInStock in the side cart's finalise
     path, which re-checks live stock at the moment of cart-add. The
     prune just keeps the UI honest in the meantime. */
  /* Savings-claim paint rides the same schedule as the prune: the kit
     math the ceiling prefers is installed by the side cart's kit IIFE,
     which renders AFTER this snippet. Re-fires on FX / currency change
     because the projection is per-market. Idempotent. */
  function scheduleSavingsPaint() { try { paintSavingsPct(); } catch (e) {} }
  scheduleSavingsPaint();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSavingsPaint);
  }
  window.addEventListener('load', scheduleSavingsPaint);
  document.addEventListener('hgn:fx:update', scheduleSavingsPaint);
  document.addEventListener('shopify:currency:update', scheduleSavingsPaint);
  document.addEventListener('hgn:kit:change', scheduleSavingsPaint);

  function schedulePrune() {
    try { pruneUnavailableGiftPicks(); } catch (e) {}
  }
  schedulePrune();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedulePrune);
  }
  window.addEventListener('load', schedulePrune);
})();

/* ---- original <script> block #2 of 4 ---- */

(function () {
  'use strict';
  if (window.__hgnKitBeaconBooted) return;
  window.__hgnKitBeaconBooted = true;
  if (!window.HGN || !window.HGN.kitProgress) return;
  var kp = window.HGN.kitProgress;

  var ENDPOINT = 'https://popup.holygrailnail.co/api/kit/progress';
  /* Private label copies — the side-cart kit IIFE keeps its own locked away. */
  var TIER_LABEL = { classic: 'Classic Wraps Kit', gels: 'Gel Wraps Kit', 'press-ons': 'Press-On Kit' };
  var TIER_NOUN = { classic: 'Nail Wrap', gels: 'Gel Wrap', 'press-ons': 'Press-On' };
  var ACCESSORY_LABELS = {
    topCoat: 'Top Coat', uvLamp: 'UV Lamp', remover: 'Press-On Remover',
    tabs: 'Application Tabs', glue: 'Press-On Glue', giftBag: 'Gift Bag',
    magicRemover: 'Magic Remover'
  };

  function analyticsAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed() !== false;
      }
    } catch (e) {}
    return true;
  }

  function snapshot(tier) {
    try {
      var s = kp.read();
      var kit = s.kits && s.kits[tier];
      if (!kit) return null;
      var minimum = kp.tierMaximum(tier) || 0;
      var required = (kp.REQUIRED_ACCESSORY_SLOTS && kp.REQUIRED_ACCESSORY_SLOTS[tier]) || [];
      var items = kit.items || [];
      var acc = kit.accessories || {};
      var filled = [];
      var missingSlots = [];
      for (var ri = 0; ri < required.length; ri++) {
        if (acc[required[ri]]) filled.push(required[ri]); else missingSlots.push(required[ri]);
      }
      var missing = [];
      if (items.length < minimum) {
        var left = minimum - items.length;
        missing.push(left + ' more ' + (TIER_NOUN[tier] || 'design') + (left === 1 ? '' : 's'));
      }
      for (var mi = 0; mi < missingSlots.length; mi++) {
        missing.push(ACCESSORY_LABELS[missingSlots[mi]] || missingSlots[mi]);
      }
      var picks = [];
      for (var pi = 0; pi < items.length && picks.length < 12; pi++) {
        picks.push({
          step: 'design',
          handle: items[pi].handle || '',
          title: items[pi].title || '',
          image: items[pi].image || ''
        });
      }
      for (var fi = 0; fi < filled.length && picks.length < 12; fi++) {
        var a = acc[filled[fi]] || {};
        picks.push({
          step: filled[fi],
          handle: a.handle || '',
          title: a.title || (ACCESSORY_LABELS[filled[fi]] || filled[fi]),
          image: a.image || ''
        });
      }
      var stepsTotal = minimum + required.length;
      var stepsDone = Math.min(items.length, minimum) + filled.length;
      /* Savings parity (KIT-TRACK.md §3.1) — reuse the SITE's own kit math
         (exposed by the side-cart kit IIFE) so the emailed figures reconcile
         with the side cart to the penny. Building kits quote the projected
         full-kit math (the same "save up to" promise the kit bar paints);
         complete kits quote the actual locked math. Guarded on every step:
         if the side cart hasn't booted, or the math has no local overlay on
         a non-GBP market, we send no figures (0 = absent server-side, which
         never overwrites a previously stored value). */
      var kitPriceCents = 0, savingsCents = 0, moneyCurrency = '';
      try {
        var mathFn = (stepsDone >= stepsTotal && window.HGN && typeof window.HGN.computeKitMath === 'function')
          ? window.HGN.computeKitMath
          : (window.HGN && typeof window.HGN.computeProjectedKitMath === 'function'
              ? window.HGN.computeProjectedKitMath : null);
        var math = mathFn ? mathFn(tier, kit) : null;
        if (math && math.local && math.local.currency) {
          moneyCurrency = String(math.local.currency).toUpperCase();
          kitPriceCents = Math.round((math.local.kitPrice || 0) * 100);
          savingsCents  = Math.round((math.local.savings  || 0) * 100);
        } else if (math) {
          var active = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
          if (active === 'GBP') {
            moneyCurrency = 'GBP';
            kitPriceCents = Math.round((math.kitPrice || 0) * 100);
            savingsCents  = Math.round((math.savings  || 0) * 100);
          }
        }
      } catch (eMath) {}
      return {
        tier: tier,
        stepsTotal: stepsTotal,
        stepsDone: stepsDone,
        missing: missing,
        picks: picks,
        itemCount: items.length,
        kitPriceCents: kitPriceCents,
        savingsCents: savingsCents,
        moneyCurrency: moneyCurrency
      };
    } catch (e) { return null; }
  }

  function send(snap, state) {
    try {
      if (!snap || !analyticsAllowed()) return;
      var did = '';
      try { did = localStorage.getItem('hgn:did') || ''; } catch (e) {}
      /* Never mint here — but a logged-in shopper without a popup did
         still gets a stable per-customer key so tracking never drops. */
      if (!did && window.HGN_CUSTOMER_ID) did = 'cust-' + String(window.HGN_CUSTOMER_ID);
      if (!did) return;
      var payload = JSON.stringify({
        did: did,
        email: window.HGN_CUSTOMER_EMAIL || '',
        tier: snap.tier,
        stepsTotal: snap.stepsTotal,
        stepsDone: snap.stepsDone,
        state: state,
        missing: snap.missing,
        picks: snap.picks,
        /* §3.1: the currency the FIGURES are denominated in wins over the
           page's active currency, so price + currency can never disagree. */
        currency: snap.moneyCurrency ||
          (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP',
        kitPriceCents: snap.kitPriceCents || 0,
        savingsCents: snap.savingsCents || 0,
        page: location.pathname
      });
      /* text/plain, NOT application/json — cross-origin sendBeacon
         silently drops non-safelisted content types (no preflight
         possible), and the worker JSON-parses the raw body regardless.
         Same transport as the popup pixel. */
      var sent = false;
      try {
        if (navigator.sendBeacon) {
          sent = navigator.sendBeacon(ENDPOINT, new Blob([payload], { type: 'text/plain' }));
        }
      } catch (e) {}
      if (!sent) {
        fetch(ENDPOINT, {
          method: 'POST',
          body: payload,
          credentials: 'omit',
          keepalive: true
        }).catch(function () {});
      }
    } catch (e) {}
  }

  var timers = {};
  var pendingComplete = {};

  function scheduleBuilding(tier) {
    if (timers[tier]) clearTimeout(timers[tier]);
    timers[tier] = setTimeout(function () {
      timers[tier] = null;
      var snap = snapshot(tier);
      if (snap && snap.itemCount > 0) send(snap, 'building');
    }, 2000);
  }

  document.addEventListener('hgn:kit:change', function (e) {
    try {
      var d = (e && e.detail) || {};
      var action = d.action || '';
      var tier = d.kit || '';
      if (!tier || !TIER_LABEL[tier]) return;

      /* Completion (no dedicated event): armed on the accessory-set that
         satisfies the tier, confirmed by autoFinalise's success 'clear'.
         IMPORTANT (2026-08-01 soak finding): autoFinalise clears each
         accessory slot BEFORE clearKit, so accessory-clear must NOT
         disarm — instead the armed snapshot lives inside a 20s window
         (finalise runs in ~1-2s; a manual delete-kit takes far longer).
         Design 'remove' still disarms immediately. */
      if (action === 'clear' && pendingComplete[tier]) {
        var armed = pendingComplete[tier];
        pendingComplete[tier] = null;
        if (timers[tier]) { clearTimeout(timers[tier]); timers[tier] = null; }
        if (armed.at && (Date.now() - armed.at) < 20000) {
          send(armed.snap, 'completed');
        }
        return;
      }
      if (action === 'remove') pendingComplete[tier] = null;

      if (action === 'add' || action === 'remove' || action === 'accessory-set' ||
          action === 'accessory-clear' || action === 'cart-to-kit-migrated') {
        if (action === 'accessory-set') {
          try {
            var s = kp.read();
            var kit = s.kits && s.kits[tier];
            if (kit && kit.items.length >= (kp.tierMaximum(tier) || 0) &&
                typeof kp.accessoriesComplete === 'function' && kp.accessoriesComplete(tier)) {
              var full = snapshot(tier);
              if (full) {
                full.stepsDone = full.stepsTotal;
                full.missing = [];
                pendingComplete[tier] = { snap: full, at: Date.now() };
              }
            }
          } catch (e2) {}
        }
        scheduleBuilding(tier);
      }
    } catch (err) {}
  });
})();

/* ---- original <script> block #3 of 4 ---- */

(function () {
  'use strict';
  if (window.__hgnKitCompleteBooted) return;
  window.__hgnKitCompleteBooted = true;

  var m = (location.search || '').match(/[?&]hgn_kit_complete=([a-z0-9]{12,24})/);
  if (!m) return;
  var token = m[1];

  /* Strip our param immediately (reloads/shares must not re-trigger);
     utm_* params stay for analytics attribution. */
  try {
    var u = new URL(location.href);
    u.searchParams.delete('hgn_kit_complete');
    history.replaceState(null, '', u.pathname + u.search + u.hash);
  } catch (e) {}

  fetch('https://popup.holygrailnail.co/api/kit/complete?token=' + encodeURIComponent(token), {
    credentials: 'omit'
  })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      if (!data || !data.ok || !data.tier || !Array.isArray(data.designs)) return;
      var tier = data.tier;
      var tries = 0;

      var populate = function (kp) {
        try {
          kp.setFocus(tier);
          /* Merge-only fill to the design minimum. getKit re-read per
             design so the count stays honest as we add. */
          var min = kp.tierMaximum(tier) || 0;
          data.designs.forEach(function (d) {
            if (!d || !d.id) return;
            var kit = kp.getKit(tier);
            if (((kit && kit.items) || []).length >= min) return;
            if (kp.hasItem(tier, d.id)) return;
            kp.addItem(tier, {
              id: d.id,
              handle: d.handle || '',
              title: d.title || '',
              image: d.image || ''
            });
          });
          /* Unpicked REQUIRED slots take the first configured option —
             the same default the drawer presents first. Gift slots with
             nothing left to offer are already absent from
             requiredSlotsFor, so this can never wedge on an empty slot. */
          (kp.requiredSlotsFor(tier) || []).forEach(function (slot) {
            if (kp.getAccessory(tier, slot)) return;
            var opts = (window.HGN_KIT_ACCESSORIES[tier] || {})[slot];
            if (Array.isArray(opts) && opts[0] && opts[0].id) {
              kp.setAccessory(tier, slot, opts[0]);
            }
          });
        } catch (e) {}
      };

      var attempt = function () {
        tries++;
        var kp = window.HGN && window.HGN.kitProgress;
        /* Wait for the controller AND the accessory broadcast (the
           announcement section renders after this snippet) — ~10s max. */
        if (!kp || !window.HGN_KIT_ACCESSORIES) {
          if (tries < 20) setTimeout(attempt, 500);
          return;
        }
        if (!kp.isTierEnabled(tier)) return; // market has this kit switched off
        if (kp.getKitBuildMode() === 'on') {
          populate(kp);
        } else {
          kp.setKitBuildMode('on', { focus: tier, skipFocusModal: true, source: 'kit-complete-email' })
            .then(function () { populate(kp); })
            .catch(function () {});
        }
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', attempt);
      } else {
        attempt();
      }
    })
    .catch(function () {});
})();

/* ---- original <script> block #4 of 4 ---- */

(function () {
  'use strict';
  if (window.__hgnReplenBasketBooted) return;
  window.__hgnReplenBasketBooted = true;

  var m = (location.search || '').match(/[?&]hgn_basket=([a-z0-9]{12,24})/);
  if (!m) return;
  var token = m[1];

  /* Strip our param immediately (reloads/shares must not re-add);
     utm_* params stay for attribution. */
  try {
    var u = new URL(location.href);
    u.searchParams.delete('hgn_basket');
    history.replaceState(null, '', u.pathname + u.search + u.hash);
  } catch (e) {}

  /* One add per browser session per token — a re-open of the same email
     link must not double the basket. */
  try {
    if (sessionStorage.getItem('hgn-basket-auto') === token) return;
  } catch (e) {}

  fetch('https://popup.holygrailnail.co/api/replen/basket?token=' + encodeURIComponent(token), {
    credentials: 'omit'
  })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      if (!data || !data.ok || !Array.isArray(data.items) || !data.items.length) return;
      var lines = data.items
        .filter(function (it) { return it && it.variant_id; })
        .map(function (it) { return { id: it.variant_id, quantity: it.qty || 1 }; });
      if (!lines.length) return;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: lines })
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (added) {
          if (!added) return;
          try { sessionStorage.setItem('hgn-basket-auto', token); } catch (e) {}
          /* The email's code rides with the basket (worker v .62). Park it
             where the side cart's welcome auto-apply looks — HGNPopup's
             held-code state — BEFORE the drawer opens, so the code is
             applied on open. Direct merge if the popup snippet has not
             booted yet (same key, same field names). */
          try {
            var fc = data.code;
            if (fc && fc.code) {
              if (window.HGNPopup && typeof window.HGNPopup.holdCode === 'function') {
                window.HGNPopup.holdCode(fc);
              } else if (String(fc.code).toUpperCase().indexOf('POPUP-') === 0 && fc.expiresAt) {
                var k = 'hgn-popup:state', cur = {};
                try { cur = JSON.parse(localStorage.getItem(k) || '{}') || {}; } catch (e) { cur = {}; }
                cur.code = String(fc.code).toUpperCase(); cur.expiresAt = fc.expiresAt;
                cur.offerLabel = fc.label || ''; cur.subscribed = true; cur.timestamp = Date.now();
                localStorage.setItem(k, JSON.stringify(cur));
              }
            }
          } catch (e) {}
          var openCart = function () {
            /* Broadcast with a real cart payload — some hgn:cart:change
               listeners read e.detail.cart — then open (the drawer also
               re-reads /cart.js on open, so this only pre-warms). */
            fetch('/cart.js')
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (cart) {
                try {
                  if (cart) document.dispatchEvent(new CustomEvent('hgn:cart:change', { detail: { cart: cart } }));
                } catch (e) {}
              })
              .catch(function () {})
              .then(function () {
                try { document.dispatchEvent(new CustomEvent('hgn:cart:open')); } catch (e) {}
              });
          };
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function () { setTimeout(openCart, 400); });
          } else {
            setTimeout(openCart, 400);
          }
        });
    })
    .catch(function () {});
})();
